"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var xs = 480;
var sm = 768;
var md = 992;
var lg = 1098;
var xl = 1400;
var xsMax = sm - 1;
var smMax = md - 1;
var mdMax = lg - 1;
var lgMax = xl - 1;
exports.default = {
  xs: xs,
  sm: sm,
  md: md,
  lg: lg,
  xl: xl,
  xsMax: xsMax,
  smMax: smMax,
  mdMax: mdMax,
  lgMax: lgMax
};